<template>
	<div class="h5-scheme-page">
		<div class="detail-infos m16">
			最终选定配置的储能规模为
			<span class="special">{{ stateInfo.power }}kW/{{ stateInfo.capacity }}kWh</span>
			，采用
			<span class="special">{{ stateInfo.strategyTypeStr }}</span>
		</div>
		<div class="detail-infos m8">
			在该储能配置下，在模拟运行的365天中，储能系统日均充放电次数为
			<span class="special">{{ stateInfo.timesDayMean }}</span>
			次，其余参数如下：
		</div>

		<div class="line-infos">
			<div :class="index % 2 === 0 ? 'line has-bg' : 'line'" v-for="(row, index) in infos">
				<div class="line-box" v-for="(el, c) in row">
					<div class="label">{{ el.name }}({{ el.unit }})</div>
					<div class="value">
						{{ infosData[el.props] }}
					</div>
				</div>
			</div>
		</div>

		<div class="detail-infos" style="margin-top: 24px; margin-bottom: 8px">
			以典型日
			<span class="special">2022年9月21日</span>
			为例，具体模拟运行效果示例如下：
		</div>

		<div class="echarts mt0">
			<div class="echarts-title">总表有功功率</div>
			<!-- 总表有功功率 -->
			<div class="echarts-box">
				<echarts-component :options="powerOptions"></echarts-component>
			</div>
		</div>
		<div class="echarts">
			<div class="echarts-title">年尖峰平谷电量对比</div>
			<!-- 年尖峰平谷电量对比 -->
			<div class="echarts-box">
				<echarts-component :options="electricOptions"></echarts-component>
			</div>
		</div>
		<div class="echarts">
			<div class="echarts-title">年尖峰平谷电费对比</div>
			<!-- 年尖峰平谷电费对比 -->
			<div class="echarts-box">
				<echarts-component :options="electricCostOptions"></echarts-component>
			</div>
		</div>

		<div class="info-tips mt16">可以看出，储能可以带来明显的削峰填谷效果。</div>
	</div>
</template>

<script setup>
// 引入echarts
import EchartsComponent from "@/components/EchartsComponent.vue";
import {toFixed, defaultOptions, map} from "@/plugins/index.js";
import {ref, defineProps, watch} from "vue";
import {mackElecOptios} from "../../../../../plugin";

// let map = {
// 	sharp: "尖",
// 	peak: "峰",
// 	flat: "平",
// 	valley: "谷",
// 	ravine: "深谷",
// };

const props = defineProps({
	schemeMethodsInfo: {
		type: Object,
		default: () => {
			return null;
		},
	},
	typicalDates: {
		type: Array,
		default: () => {
			return [];
		},
	},
});
const stateInfo = ref({});

const infos = ref([
	[
		{
			name: "总充电量",
			unit: "MWh",
			props: "elecChargeTotal",
		},
		{
			name: "日均充电量",
			unit: "kWh",
			props: "elecChargeDayMean",
		},
	],
	[
		{
			name: "总放电量",
			unit: "MWh",
			props: "elecDischargeTotal",
		},
		{
			name: "日均放电量",
			unit: "kWh",
			props: "elecDischargeDayMean",
		},
	],
	[
		{
			name: "总充电成本",
			unit: "元",
			props: "chargeCostTotal",
		},
		{
			name: "日均充电成本",
			unit: "元/天",
			props: "chargeCostDayMean",
		},
	],
	[
		{
			name: "总放电收益",
			unit: "元",
			props: "dischargeIncomeTotal",
		},
		{
			name: "日均放电收益",
			unit: "元/天",
			props: "dischargeIncomeDayMean",
		},
	],
	[
		{
			name: "总收益",
			unit: "元",
			props: "benefitTotal",
		},
		{
			name: "日均收益",
			unit: "元/天",
			props: "benefitDayMean",
		},
	],
]);
const infosData = ref({});

const powerOptions = ref({});
const electricOptions = ref({});
const electricCostOptions = ref({});

// 生成信息栏信息
const makeInfosData = info => {
	console.log(info);

	if (info != null) {
		console.log(info.elecChargeTotal);
		const {
			elecChargeTotal,
			elecDischargeTotal,
			chargeCostTotal,
			dischargeIncomeTotal,
			benefitTotal,
			benefitDayMean,
			elecChargeDayMean,
			elecDischargeDayMean,
			chargeCostDayMean,
			dischargeIncomeDayMean,
		} = info;

		infosData.value = {
			elecChargeTotal: toFixed(elecChargeTotal / 1000),
			elecDischargeTotal: toFixed(elecDischargeTotal / 1000),
			chargeCostTotal: toFixed(chargeCostTotal),
			dischargeIncomeTotal: toFixed(dischargeIncomeTotal),
			benefitTotal: toFixed(benefitTotal),
			benefitDayMean: toFixed(benefitDayMean),
			elecChargeDayMean: toFixed(elecChargeDayMean),
			elecDischargeDayMean: toFixed(elecDischargeDayMean),
			chargeCostDayMean: toFixed(chargeCostDayMean),
			dischargeIncomeDayMean: toFixed(dischargeIncomeDayMean),
		};
	}
};

// 绘制总表有功图表
const makePowOptions = (typical = [], timeRanges = [], demandLimit = 0) => {
	// 绘制总表有功功率图
	let x_data = [];
	let y_data1 = [],
		y_data2 = [];
	console.log(typical);
	typical.map(el => {
		x_data.push(el.time);
		y_data1.push(el ? toFixed(el.before, 2) : "-");
		y_data2.push(el ? toFixed(el.after, 2) : "-");
	});
	console.log(y_data1, y_data2);
	let allTimes = [...x_data];
	let markAreaData = [];

	if (props.typicalDates.length > 0) {
		timeRanges[props.typicalDates[0]].map(el => {
			allTimes.push(el.start);
			allTimes.push(el.end);
			markAreaData.push([
				{
					name: map[el.type],
					xAxis: el.start,
					itemStyle: {
						color:
							el.type == "sharp"
								? "rgba(197,202,213,0.6)"
								: el.type == "peak"
								? "rgba(197,202,213,0.5)"
								: el.type == "flat"
								? "rgba(197,202,213,0.4)"
								: el.type == "valley"
								? "rgba(197,202,213,0.3)"
								: "rgba(197,202,213,0.2)",
					},
				},
				{
					xAxis: el.end,
				},
			]);
		});
	}

	let powOptions = {
		...JSON.parse(JSON.stringify(defaultOptions)),
		series: [
			{
				name: "需量限制",
				data: Array(x_data.length).fill(toFixed(demandLimit, 2)),
				type: "line",
				symbol: "none", // 去除圆点
				lineStyle: {
					type: "dashed",
					width: 2,
				},
			},
			{
				name: "配储前",
				data: y_data1,
				type: "line",
				symbol: "none", // 去除圆点
			},
			{
				name: "配储后",
				data: y_data2,
				type: "line",
				symbol: "none", // 去除圆点
			},
			{
				name: "scatter",
				type: "scatter",
				markArea: {
					data: markAreaData,
				},
			},
		],
	};

	powOptions.xAxis.data = [...new Set(allTimes)].sort();
	powOptions.yAxis.name = "总表有功功率/kW";
	powOptions.yAxis.nameTextStyle.padding = [0, 0, 8, 0];
	powOptions.color = ["#F40D0D", "#7C92BA", "#0082FC"];
	powOptions.legend.data = ["需量限制", "配储前", "配储后"];
	powOptions.grid.top = "16%";
	powOptions.tooltip = {
		trigger: "axis",
		formatter: params => {
			const seriesData1 = params[0];
			const seriesData2 = params[1];
			let str = `<span style='font-weight:600'>${seriesData1.name}</span>`;
			params.map(el => {
				str += ` <br> ${el.marker} ${el.seriesName}：${el.data} kW `;
			});
			return str;
		},
	};
	console.log(powOptions);
	powerOptions.value = powOptions;
	console.log(`powOptions：`, powOptions);
};

watch(
	() => props.schemeMethodsInfo,
	newVal => {
		if (newVal) {
			console.log(newVal);
			stateInfo.value = {
				capacity: newVal.capacity,
				power: newVal.power,
				strategyTypeStr: newVal.strategyType == 1 ? "固定策略" : "智能策略",
				timesDayMean: newVal.strategyInfo.timesDayMean,
			};

			// 生成信息栏
			makeInfosData(newVal.strategyInfo);

			// 绘制图表
			const {typical, timeRanges, demandLimit, elecCompare, feeCompare} = newVal.strategyInfo;
			let typicalData = [];
			console.log(typical);
			console.log(props.typicalDates);
			if (typical) {
				typicalData = typical[props.typicalDates[0]];
			}

			// 绘制总表有功
			makePowOptions(typicalData, timeRanges, demandLimit);
			// 绘制电量对比
			electricOptions.value = mackElecOptios(elecCompare, "MWh", "h5");
			// 绘制电费对比
			electricCostOptions.value = mackElecOptios(feeCompare, "万元", "h5");
		}
	},
	{immediate: true, deep: true}
);
</script>

<style lang="less" scoped>
.h5-scheme-page {
	margin-top: 16px;

	.line-infos {
		.line {
			// height: 44px;
			background: #a2abbb0a;
			display: flex;
			padding: 11px 12px;

			.line-box {
				flex: 1;
				// display: flex;
				// align-items: center;
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				letter-spacing: 0;
				.label {
					opacity: 0.65;
					font-family: PingFangSC-Regular;
					margin-bottom: 4px;
				}
				.value {
					opacity: 0.85;
					font-family: PingFangSC-Medium;
					font-weight: 600;
				}
			}
		}
		.has-bg {
			background-color: #a2abbb29;
		}
	}
	.m16 {
		margin-bottom: 16px;
	}
	.m8 {
		margin-bottom: 8px;
	}
}
.mt16 {
	margin-top: 16px;
}

.echarts {
	margin-top: 24px;
	&-title {
		border-left: 4px solid #0058fc;
		height: 24px;
		opacity: 0.85;
		font-family: PingFangSC-Medium;
		font-weight: 500;
		font-size: 16px;
		color: #000000;
		letter-spacing: 0;
		line-height: 24px;
		padding-left: 8px;
	}
	&-box {
		height: 251px;
		margin-top: 16px;
	}
}
.mt0 {
	margin-top: 0px;
}
</style>
